import { Box, Text } from '@bechtel/gds';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UnderConstruction } from '~/components/under-construction';
import { FeaturesContainer } from './styled';

export const Features: FC = () => {
  const { t } = useTranslation();
  return (
    <FeaturesContainer>
      <Box>
        <Text family="openSansSemiBold" weight="600" size="500" color="neutral.800">
          {t('FEATURES')}
        </Text>
      </Box>
      <UnderConstruction></UnderConstruction>
    </FeaturesContainer>
  );
};
